__turbopack_export_value__({
  "badge": "floatingRatingBadge-module-scss-module__Dbnm9W__badge",
});
